import React, { useState, useRef, useEffect } from 'react'
import Page1 from '../assets/Page1-Traffic.png'
import Input from '../components/Input'
import Dropdown from '../components/Dropdown'
import { getUrlParams, randomString } from '../common'
import MyDropzone from '../components/MyDropzone'
import Checkbox from '../components/Checkbox'
import SignatureCanvas from 'react-signature-canvas'
import axios from 'axios'
import { format, isAfter } from 'date-fns'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { clearPageMessage, showLoadingMessage, showSuccessMessage, showWarningMessage } from '../successMessage'
import { doc, getDoc } from 'firebase/firestore'
import { db } from '../firebase-config'
import { getOrderedStudentTasks, isTaskSubmitted } from '../trafficCourseFlowUtils'

const DeclarationTraffic = () => {

    const [page, setPage] = useState(0)
    const [errors, setErrors] = useState([])
    const [errorMessage, setErrorMessage] = useState('')
    const [loading, setLoading] = useState(false)
    const [contextLoading, setContextLoading] = useState(Boolean(getUrlParams().sid))
    const [contextError, setContextError] = useState('')
    const [sourceFlowId, setSourceFlowId] = useState('')

    const [statementTraningNumber, setStatementTraningNumber] = useState('')
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [dob, setDob] = useState('')
    const [signatureString, setSignatureString] = useState('')

    const [declarationDate, setDeclarationDate] = useState(format(new Date(), 'dd-MM-yyyy'))

    const signatureRef = useRef()


    const [improve, setImprove] = useState('')
    const [bestAspect, setBestAspect] = useState('')
    const [qualification, setQualification] = useState('')
    const [broadField, setBroadfield] = useState('')
    const [trainingTitle, setTrainingTitle] = useState('')
    const [startTraining, setStartTraining] = useState('')


    const [gender, setGender] = useState('')
    const [age, setAge] = useState('')
    const [aboriginal, setAboriginal] = useState('')
    const [postcode, setPostcode] = useState('')

    const [trainerId, setTrainerId] = useState('')

    const [delivery, setDelivery] = useState('')

    const questions = [
        'I developed the skills expected from this training.',
        'I identified ways to build on my current knowledge and skills.',
        'The training focused on relevant skills.',
        'I developed the knowledge expected from this training',
        'The training prepared me well for work.',
        'I set high standards for myself in this training',
        'The training had a good mix of theory and practice.',
        'I looked for my own resources to help me learn',
        'Overall, I am satisfied with the training.',
        'I would recommend the training organisation to others.',
        'Training organisation staff respected my background and needs.',
        'I pushed myself to understand things I found confusing.',
        'Trainers had an excellent knowledge of the subject content.',
        'I received useful feedback on my assessments. ',
        'The way I was assessed was a fair test of my skills and knowledge.',
        'I learned to work with people.',
        'The training was at the right level of difficulty for me.',
        'The amount of work I had to do was reasonable.',
        'Assessments were based on realistic activities.',
        'It was always easy to know the standards expected.',
        'Training facilities and materials were in good condition',
        'I usually had a clear idea of what was expected of me.',
        'Trainers explained things clearly.',
        'The training organisation had a range of services to support learners.',
        'I learned to plan and manage my work.',
        'The training used up-to-date equipment, facilities and materials.',
        'I approached trainers if I needed help.',
        'Trainers made the subject as interesting as possible.',
        'I would recommend the training to others.',
        'The training organisation gave appropriate recognition of existing knowledge and skills',
        'Training resources were available when I needed them.',
        'I was given enough material to keep up my interest.',
        'The training was flexible enough to meet my needs.',
        'Trainers encouraged learners to ask questions.',
        'Trainers made it clear right from the start what they expected from me.'
    ]

    const yesNoQuestions = [
        'Are you undertaking an APPRENTICESHIP Or TRAINEESHIP?',
        'Did you get any RECOGNITION OF PRIOR LEARNING towards your training such as subject exemptions, course credits or advanced standing?',
        'Do you speak a LANGUAGE OTHER THAN ENGLISH at home? ',
        'Are you a PERMANENT RESIDENT Or CITIZEN of Australia?',
        'Do you consider yourself to have a DISABILITY, IMPAIRMENT, or LONG-TERM CONDITION',
    ]


    const qualificationOptions = [
        'Certificate I',
        'Certificate II',
        'Certificate III',
        'Certificate IV',
        'Certificate level unknown',
        'Diploma',
        'Advanced diploma',
        'Associate degree',
        'Degree',
        'Short course or statement of attainment',
        'VET graduate certificate or graduate diploma',
        'Other qualification or training',
        'Do not know'
    ]

    const broadFieldOptions = [
        ' Natural and physical sciences',
        'Information technology',
        'Engineering and related technologies',
        'Architecture and building',
        'Agriculture, environmental and related studies',
        'Health',
        'Education',
        'Management and commerce',
        'Society and culture',
        'Creative arts',
        'Food, hospitality and personal services',
        'Other'
    ]


    const genderOptions = ['Female/Woman', 'Male/Man', 'Non-binary', 'Prefer Not to Answer']

    const ageOptions = ['Under 15', '15 to 19', '20 to 24', '25 to 34', '35 to 44', '45 to 54', '55 to 64', '65 or over']

    const aboriginalOptions = ['No', 'Yes, Aboriginal', 'Yes, Torres Strait Islander', 'Yes, both Aboriginal and Torres Strait Islander']



    const [aboutTrainingAnswers, setAboutTrainingAnswers] = useState([...Array(questions.length).keys()].map(i => ''))
    const [yesNoAnswers, setYesNoAnswers] = useState([...Array(yesNoQuestions.length).keys()].map(i => ''))


    const navigate = useNavigate()

    const firstPageValidations = [
        { name: 'firstName', value: firstName },
        { name: 'lastName', value: lastName },
        { name: 'dob', value: dob },
        // { name: 'statementTraningNumber', value: statementTraningNumber },
    ]

    const secondPageValidations = [
        { name: 'aboutTrainingAnswers', value: aboutTrainingAnswers, array: true },
        { name: 'bestAspect', value: bestAspect },
        { name: 'improve', value: improve },
        { name: 'qualification', value: qualification },
        { name: 'broadField', value: broadField },
        { name: 'trainingTitle', value: trainingTitle },
        { name: 'startTraining', value: startTraining },
        { name: 'gender', value: gender },
        { name: 'age', value: age },
        { name: 'aboriginal', value: aboriginal },
        { name: 'yesNoAnswers', value: yesNoAnswers, array: true },
        { name: 'postcode', value: postcode },
    ]

    useEffect(() => {
        const params = getUrlParams()
        if (params.sid) {
            let cancelled = false
            const loadContext = async () => {
                try {
                    const snapshot = await getDoc(doc(db, 'trafficCourseFlows', params.sid))
                    if (!snapshot.exists()) throw new Error('Assessment not found. Please contact your trainer.')
                    const flow = snapshot.data()
                    const expectedCourse = window.location.pathname === '/dec-trafficControl' ? 'traffic-controller' : 'traffic-implementer'
                    if (flow.linkedCourse !== expectedCourse) throw new Error('This declaration does not match your course. Please return to your assessment.')
                    const tasks = getOrderedStudentTasks(flow)
                    if (!tasks.length || !tasks.every(task => isTaskSubmitted(flow, task.id))) throw new Error('Please finish your assessment before starting this declaration.')
                    if (!flow.trainerId || !flow.delivery) throw new Error('Trainer or delivery details are missing. Please contact your trainer.')
                    if (cancelled) return
                    setTrainerId(flow.trainerId)
                    setDelivery(flow.delivery)
                    setFirstName(flow.firstName || '')
                    setLastName(flow.lastName || '')
                    const rawDob = String(flow.dob || '')
                    const isoDob = rawDob.match(/^(\d{4})-(\d{2})-(\d{2})$/)
                    const localDob = rawDob.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/)
                    setDob(isoDob ? `${isoDob[3]}/${isoDob[2]}/${isoDob[1]}`
                        : localDob ? `${localDob[1].padStart(2, '0')}/${localDob[2].padStart(2, '0')}/${localDob[3]}` : rawDob)
                    setTrainingTitle(flow.courseName || '')
                    setSourceFlowId(snapshot.id)
                } catch (error) {
                    if (!cancelled) setContextError(error.message || 'Unable to load your assessment details. Please try again.')
                } finally {
                    if (!cancelled) setContextLoading(false)
                }
            }
            loadContext()
            return () => { cancelled = true }
        }
        if (params.trainerId || params.trainerid) {
            setTrainerId(params.trainerId || params.trainerid)
        } else {
            toast.error('Trainer ID is required!!!', { position: 'top-center' })
        }

        if (params.delivery) {
            setDelivery(params.delivery[0].toUpperCase() + params.delivery.substring(1))
        } else {
            toast.error('Delivery method is required!!!', { position: 'top-center' })
        }
    }, [])

    const handleNext = async () => {

        let tempErrors = []
        if (page === 1) {
            firstPageValidations.forEach(row => {
                if (!row.value) {
                    tempErrors.push(row.name)
                }
            })
            if (tempErrors.length > 0) {
                setErrors(tempErrors)
                setErrorMessage('Please fill all the fields.')
                return
            }

            if (!dob.match(/^(0[1-9]|[12][0-9]|3[01])[\/](0[1-9]|1[012])[\/](19|20)\d\d$/)) {
                setErrors(['dob'])
                setErrorMessage('Please enter a valid DOB & match expected format.')
                return
            } else if (isAfter(new Date(dob.split('-')[2] + '/' + dob.split('-')[1] + '/' + dob.split('-')[0]), new Date())) {
                setErrors(['dob'])
                setErrorMessage('Please enter a valid DOB. DOB should be in the past.')
                return
            }

            if (signatureRef.current.isEmpty()) {
                setErrors('signature')
                setErrorMessage('Please provide your signature.')
                return
            }

            setSignatureString(signatureRef.current.getTrimmedCanvas().toDataURL('image/png'))

        } else if (page === 2 && window.location.pathname.includes('trafficControl')) {

            secondPageValidations.forEach(row => {

                if (row.array) {
                    console.log(row.name, row.value)
                    if (row.value.length === 0 || row.value.filter(r => !r).length > 0) {
                        tempErrors.push(row.name)
                    }
                } else if (!row.value) {
                    tempErrors.push(row.name)
                }
            })
            if (tempErrors.length > 0) {
                setErrors(tempErrors)
                setErrorMessage('Please fill all the fields.')
                return
            }

        }
        setErrorMessage('')
        setErrors([])
        page !== 2 && setPage(page + 1)

        setTimeout(() => {
            signatureRef && signatureRef.current && signatureString && signatureRef.current.fromDataURL(signatureString)
        }, 200)

        if (page === 2) {
            // Submit form and generate PDF

            setLoading(true)
            showLoadingMessage('Submitting Declaration')
            try {
                const resp = await axios.post('https://australia-southeast1-upskillinstitute-au.cloudfunctions.net/fillDeclarationTraffic', {
                    // const resp = await axios.post('http://127.0.0.1:5001/upskillinstitute-au/australia-southeast1/fillDeclarationTraffic', {
                    data: {
                        ...(sourceFlowId ? { sourceFlowId } : {}),
                        trainerId,
                        firstName,
                        lastName,
                        dob,
                        delivery,
                        trainingType: window.location.pathname.includes('trafficControl') ? 'dec-trafficControl' : 'dec-trafficImplementation',
                        statementTraningNumber,
                        aboutTrainingAnswers: aboutTrainingAnswers.map(r => r.value),
                        bestAspect,
                        improve,
                        broadField: broadField ? broadField.value : broadField,
                        trainingTitle,
                        startTraining,
                        gender: gender ? gender.value : gender,
                        age: age ? age.value : age,
                        aboriginal: aboriginal ? aboriginal.value : aboriginal,
                        postcode,
                        yesNoAnswers: yesNoAnswers.map(r => r.value),
                        declarationDate,
                        signature: signatureString
                    }
                }, {
                    headers: {
                        "Content-Type": "application/json",
                        "Access-Control-Allow-Origin": "*",
                    }
                })
                // Navigate back to portal
                setLoading(false)


                window.scrollTo({ top: 0, behavior: 'smooth' })
                showSuccessMessage('Declaration submitted successfully')
                navigate('/thankyou?id=declaration')

            } catch (e) {
                clearPageMessage()
                showWarningMessage(e.response?.data?.error || 'Declaration could not be submitted. Please try again.')
                setLoading(false)

                console.error('e', e)
            }

        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }

    const goToPrevPage = () => {
        if (page > 0) {
            setPage(page - 1)
            setErrorMessage('')
            setErrors([])
            // Set signature back

            setTimeout(() => {
                signatureRef && signatureRef.current && signatureString && signatureRef.current.fromDataURL(signatureString)
            }, 200)
        }
    }




    const aboutTrainingOptions = ['Strongly agree', 'Agree', 'Disagree', 'Strongly disagree',]

    console.log('aboutTrainingAnswers', aboutTrainingAnswers)

    if (contextLoading) return <div role='status' style={{ padding: '40px', textAlign: 'center' }}>Loading declaration details...</div>
    if (contextError) return <div role='alert' style={{ padding: '40px', textAlign: 'center' }}>{contextError}</div>

    return (<div className='form-wrapper'>
        <h1>Record of Training Declaration</h1>
        {
            page === 0 ?
                <img src={Page1} style={{ width: '100%' }} />
                : page === 1 ? <>


                    <p> • I have read the privacy compliance statement and consent to SafeWork NSW using my information
                        (including personal information) as outlined in that statement.</p>
                    <p> • The information supplied in this application is true and correct to the best of my knowledge. </p>

                    <label className='fieldHeading'>Applicant's Name</label>
                    <div className='flexrow'>
                        <Input bold type={'text'} errorMessage={errors.includes('firstName') && errors.length === 1 && errorMessage} errors={errors} name={'firstName'} value={firstName} setValue={setFirstName} label={'First Name'} />
                        <Input bold type={'text'} errorMessage={errors.includes('lastName') && errors.length === 1 && errorMessage} errors={errors} name={'lastName'} value={lastName} setValue={setLastName} label={'Last Name'} />
                    </div>

                    <Input bold type={'text'} errorMessage={errors.includes('dob') && errors.length === 1 && errorMessage} errors={errors} placeholder={'DD/MM/YYYY'} name={'dob'} value={dob} setValue={setDob} label={'Date of Birth (dd/mm/yyyy)'} />

                    <label className='fieldHeading'> Applicant's Signature </label>
                    <SignatureCanvas penColor='black'
                        ref={signatureRef}
                        canvasProps={{ width: 500, height: 200, className: `sigCanvas ${errors.includes('signature') ? 'error' : ''}` }} />
                    <div>
                        <button style={{ color: '#FF7100', background: 'white', border: '1px solid #FF7100' }} onClick={() => signatureRef.current.clear()}>Clear</button>
                    </div>

                    <Input bold type={'text'} placeholder={'DD-MM-YYY'} errorMessage={errors.includes('declarationDate') && errors.length === 1 && errorMessage} errors={errors} name={'declarationDate'} value={declarationDate} disabled setValue={setDeclarationDate} label={'Date of Declaration'} />

                    {/* <Input bold type={'text'} errorMessage={errors.includes('statementTraningNumber') && errors.length === 1 && errorMessage} errors={errors} name={'statementTraningNumber'} value={statementTraningNumber} setValue={setStatementTraningNumber} label={'SOT Number'} /> */}

                </> :
                    (page === 2 && window.location.pathname.includes('trafficControl')) ? <>

                        <br />

                        <b>About your training</b>



                        {questions.map((question, index) =>
                            <Dropdown key={question} options={aboutTrainingOptions} value={aboutTrainingAnswers[index]} setValue={v => setAboutTrainingAnswers(aboutTrainingAnswers.map((r, idx) => idx === index ? v : r))} label={question} errorFields={errors} name={!aboutTrainingAnswers[index] && 'aboutTrainingAnswers'} />
                        )}


                        <p>What were the BEST ASPECTS of the training?</p>
                        <textarea className={errors.includes('bestAspect') && 'error'} onChange={e => setBestAspect(e.target.value)} value={bestAspect}></textarea>

                        <p>What aspects of the training were MOST In NEED OF IMPROVEMENT?</p>
                        <textarea className={errors.includes('improve') && 'error'} onChange={e => setImprove(e.target.value)} value={improve}></textarea>
                        <br />

                        <b>Your Training details</b>


                        <Dropdown options={qualificationOptions} value={qualification} setValue={setQualification} label={'What TYPE OF QUALIFICATION are you currently enrolled in?'} errorFields={errors} name={'qualification'} />
                        <Dropdown options={broadFieldOptions} value={broadField} setValue={setBroadfield} label={'What is the BROAD FIELD of your current training?'} errorFields={errors} name={'broadField'} />


                        <p>What is the FULL TITLE of your current qualification or training?</p>
                        <textarea className={errors.includes('trainingTitle') && 'error'} onChange={e => setTrainingTitle(e.target.value)} value={trainingTitle}></textarea>


                        <Input type={'text'} errorMessage={errors.includes('startTraining') && errors.length === 1 && errorMessage} errors={errors} name={'startTraining'} value={startTraining} setValue={setStartTraining} label={'In what MONTH AND YEAR did you start your current training?'} placeholder={'MM/YYYY'} />

                        <br />
                        <b>ABOUT YOU</b>

                        <Dropdown options={ageOptions} value={age} setValue={setAge} label={'What is your age in years?'} errorFields={errors} name={'age'} />
                        <Dropdown options={genderOptions} value={gender} setValue={setGender} label={'What is your gender?'} errorFields={errors} name={'gender'} />
                        <Dropdown options={aboriginalOptions} value={aboriginal} setValue={setAboriginal} label={'Are you of ABORIGINAL or TORRES STRAIT ISLANDER origin?'} errorFields={errors} name={'aboriginal'} />


                        {yesNoQuestions.map((question, index) =>
                            <Dropdown key={question} options={['Yes', 'No']} value={yesNoAnswers[index]} setValue={v => setYesNoAnswers(yesNoAnswers.map((r, idx) => idx === index ? v : r))} label={question} errorFields={errors} name={!yesNoAnswers[index] && 'yesNoAnswers'} />
                        )}

                        <Input type={'text'} errorMessage={errors.includes('postcode') && errors.length === 1 && errorMessage} errors={errors} name={'postcode'} value={postcode} setValue={setPostcode} label={'What is the POSTCODE of your main place of residence?'} />

                    </> : (page === 2 && !window.location.pathname.includes('trafficControl')) ? <>
                        <p>You do not have any additional questions to answer. Please proceed to submit!</p>
                    </> : <></>}
        {errorMessage && errors.length > 0 && <p style={{ color: 'red', textAlign: 'center' }}>{errorMessage}</p>}

        <div style={{ display: 'flex', alignItems: 'center' }}>
            {page !== 0 && <button disabled={loading || page === 0} style={{ marginLeft: 'auto', display: 'flex', color: '#FF7100', background: 'white', border: '1px solid #FF7100' }} onClick={goToPrevPage}>Back</button>}
            <button style={{ marginLeft: page === 0 ? 'auto' : '20px', display: 'flex' }} disabled={loading} onClick={handleNext}>{loading ? 'Loading...' : (page === 2 ? 'Submit' : 'Next')}</button>
        </div>

    </div >)
}

export default DeclarationTraffic
